import { useState, useEffect, useMemo } from 'react'
import { Form } from 'react-bootstrap'
import objectPath from 'object-path'
import { isNumber } from 'designer/component/action/Data'

const CustomCheckbox = ({
  id,
  name,
  ui,
  rowData,
  onUpdateRowData,
  valueChecked,
  valueUnChecked,
  error,
  disabled,
}) => {
  const [render, setRender] = useState(false)
  let value = objectPath.get(rowData, ui.field)

  let textAlign = objectPath.get(ui, 'cellStyle.textAlign')
  let style = {
    width: '18px',
    height: '18px',
    margin: 'auto',
    marginLeft: textAlign === 'left' ? 0 : 'auto',
    marginRight: textAlign === 'right' ? 0 : 'auto',
  }

  const updateData = (checked) => {
    objectPath.set(rowData, ui.field, checked)
    onUpdateRowData(rowData)
    setRender(true)
  }

  useEffect(() => render && setRender(false), [render])

  return (
    <>
      <Form.Control
        id={id}
        name={name}
        style={style}
        type="checkbox"
        checked={value === valueChecked ? true : false}
        onChange={(e) => {
          let checked = e.target.checked
          let value = checked ? valueChecked : valueUnChecked
          updateData(value)
        }}
        disabled={disabled}
      />
    </>
  )
}

export default CustomCheckbox
